import { render, staticRenderFns } from "./GuardianshipAffidavitStep.vue?vue&type=template&id=1abdf4fe"
import script from "./GuardianshipAffidavitStep.vue?vue&type=script&lang=ts"
export * from "./GuardianshipAffidavitStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports